import { AbstractParentEntity } from "./AbstractParentEntity";
import { SuccessionPlanning } from "./tsadv$SuccessionPlanning";
import { SuccessorStatus } from "./tsadv_SuccessorStatus";
import { PersonGroupExt } from "./base$PersonGroupExt";
import { DicReadinessLevel } from "./tsadv$DicReadinessLevel";
export class Successor extends AbstractParentEntity {
  static NAME = "tsadv$Successor";
  succession?: SuccessionPlanning | null;
  status?: SuccessorStatus | null;
  dateStatus?: any | null;
  comments?: string | null;
  personGroup?: PersonGroupExt | null;
  startDate?: any | null;
  endDate?: any | null;
  readinessLevel?: DicReadinessLevel | null;
  bestReservist?: boolean | null;
  note?: string | null;
}
export type SuccessorViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "reservist"
  | "successor-view"
  | "successor-viewPersonCard"
  | "successor.browse";
export type SuccessorView<V extends SuccessorViewName> = V extends "_base"
  ? Pick<
      Successor,
      | "id"
      | "succession"
      | "personGroup"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_local"
  ? Pick<
      Successor,
      | "id"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_minimal"
  ? Pick<Successor, "id" | "succession" | "personGroup">
  : V extends "reservist"
  ? Pick<
      Successor,
      | "id"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "succession"
      | "personGroup"
      | "status"
      | "readinessLevel"
    >
  : V extends "successor-view"
  ? Pick<
      Successor,
      | "id"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "personGroup"
      | "readinessLevel"
      | "status"
      | "succession"
    >
  : V extends "successor-viewPersonCard"
  ? Pick<
      Successor,
      | "id"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "succession"
      | "readinessLevel"
    >
  : V extends "successor.browse"
  ? Pick<
      Successor,
      | "id"
      | "dateStatus"
      | "comments"
      | "startDate"
      | "endDate"
      | "note"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "succession"
      | "personGroup"
      | "readinessLevel"
      | "status"
    >
  : never;
